import { render, staticRenderFns } from "./alternative.vue?vue&type=template&id=f098139a&scoped=true&"
import script from "./alternative.vue?vue&type=script&lang=js&"
export * from "./alternative.vue?vue&type=script&lang=js&"
import style0 from "./alternative.vue?vue&type=style&index=0&id=f098139a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f098139a",
  null
  
)

export default component.exports